import PropTypes from 'prop-types';
import {
  Avatar, AvatarSizes, Typography,
} from '@leegality/leegality-react-component-library';
import {
  Popover, PopoverTrigger, PopoverContent,
} from '@components/popover';
import { logoutUser } from '@app/api';
import { useCpId } from '@app/profile-selection-store';
import { iconRenderer, IconKeys, IconColors } from '@components/icon';
import { getTranslation } from '@utils';
import './profile.scss';

const Profile = ({ userProfile }) => {
  const cpId = useCpId();

  const handleLogout = () => {
    logoutUser();
  };

  return (
    <Popover>
      <PopoverTrigger>
        <Avatar
          nameInitials={cpId?.slice(0, 2)}
          size={AvatarSizes.MEDIUM}
        />
      </PopoverTrigger>
      <PopoverContent className="topbar-profile-popover z-50 bg-white border border-gray-200 rounded-md shadow-lg overflow-hidden">
        <div className="profile-popover-info">
          <Avatar nameInitials={cpId?.slice(0, 2)} size={AvatarSizes.MEDIUM} />
          <div className="profile-popover-text">
            <Typography
              tag={Typography.Tags.SPAN}
              color={Typography.Colors.gray900}
              variant={Typography.Variants.sm}
              fontWeight={Typography.FontWeight.semibold}
              className="profile-popover-cpid"
            >
              {cpId}
            </Typography>
            {userProfile && (
              <Typography
                tag={Typography.Tags.SPAN}
                color={Typography.Colors.gray500}
                variant={Typography.Variants.xs}
                className="profile-popover-email"
              >
                {userProfile}
              </Typography>
            )}
          </div>
        </div>

        <div
          className="profile-popover-logout"
          role="button"
          tabIndex={0}
          onClick={handleLogout}
          onKeyDown={() => {}}
        >
          {iconRenderer({ iconName: IconKeys.LogOut, size: 16, color: IconColors.GRAY })}
          <Typography
            tag={Typography.Tags.SPAN}
            color={Typography.Colors.gray900}
            variant={Typography.Variants.sm}
          >
            {getTranslation('LOGOUT_LABEL')}
          </Typography>
        </div>
      </PopoverContent>
    </Popover>
  );
};

Profile.propTypes = {
  userProfile: PropTypes.string,
};

Profile.defaultProps = {
  userProfile: null,
};

export default Profile;
